<template>
  <div>
    <div id="app-first-sidebar" class="wrapper" ref="wrapper">
      <div class="content">
        <a class="team-logo-wrap" href="https://www.hkmtd.com" target="_blank">
          <img class="team-logo" src="@/assets/logo.png"/>
        </a>
        <div class="menus">
          <template v-for="(value, index) in routes">
            <div v-if="value.meta.isMenu" class="menu-item">
              <router-link :to="value.path" active-class="active">
                <i :class="value.meta.icon"></i>{{value.name}}
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 用户信息 -->
    <div @mouseover="showDropdown = true" @mouseout="showDropdown = false" class="user-info">
      <div class="user-info-button">
        {{$store.getters.name}}
      </div>
      <!-- 用户信息下拉框 -->
      <div class="user-dropdown" :class="{active: showDropdown}">
        <div class="user-dropdown-meta">
          <div>{{$store.getters.name}}</div>
        </div>
        <div class="user-dropdown-select">
          <!--<a class="link" href="">账号设置</a>-->
          <!--<a class="link" href="">切换店铺</a>-->
          <a class="link" @click="handleChangePassword">修改密码</a>
          <a class="link" @click="handleLogout">退出登录</a>
        </div>
        <div class="arrow"></div>
      </div>
    </div>
    <!-- 第二层导航栏 -->
    <div v-if="isShowSecondMenu" id="app-second-sidebar" ref="secondSidebarWrapper">
      <div class="content">
        <div class="second-sidebar-title">{{currentRoute.name}}</div>
        <template v-for="(value, index) in currentRoute.children">
          <nav v-if="value.meta.isMenu" class="second-sidebar-nav-container">
            <ul class="nav">
              <li class="nav-item">
                <router-link class="nav-item-link" active-class="active" :to="currentRoute.path+'/'+value.path">{{value.name}}</router-link>
              </li>
            </ul>
          </nav>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import BScroll from 'better-scroll'

  export default {
    name: "menu-nav",
    data() {
      return {
        showDropdown: false
      }
    },
    mounted() {
      this.$nextTick(() => {
        this._initScroll()
        if (this.isShowSecondMenu) this._initNavScroll()
      })
    },
    methods: {
      _initScroll() {
        this.scroll = new BScroll(this.$refs.wrapper, {
          click: true
        })
      },
      _initNavScroll() {
        this.navScroll = new BScroll(this.$refs.secondSidebarWrapper, {
          click: true
        })
      },
      handleChangePassword() {
        this.$router.push({ path: '/auth/user/changepassword'})
      },
      handleLogout() {
        this.$store.dispatch('Logout').then(() => {
          location.reload()
        })
      }
    },
    computed: {
      routes() {
        var tempRouters = []
        for(var i=0; i < this.$router.options.routes.length; i++)
        {
          var router = this.$router.options.routes[i]
          if (router.path != '/login') {
            tempRouters.push(router)
          }
        }
        return tempRouters
        // return this.$router.options.routes
      },
      currentRoute() {
        for(var i=0; i < this.$router.options.routes.length; i++)
        {
          var router = this.$router.options.routes[i]
          if (this.$route.path === router.path) {
            return router
          } else if (this.$route.path.indexOf(router.path+'/') === 0) {
            return router
          }
        }
        return null
      },
      isShowSecondMenu() {
        return this.currentRoute && this.currentRoute.children && (this.currentRoute.children.length>1 || this.currentRoute.alwaysShow)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/MenuNav.vue